/** saves Accounts Balances
@payload { Array }
*/
export const SAVE_ACCOUNTS_BALANCE = (state, payload) => {
	state.accountsBalances = payload.balanceViews
}

/** saves Cards List
@payload { Array }
*/
export const SAVE_CARDS = (state, payload) => {
	state.cardsList = payload
}

/** saves Available Plafond
@payload { Array }
*/
export const SAVE_PLAFOND = (state, payload) =>  {
    state.availablePlafond = payload
}

export const SAVE_EXCHANGE = (state, payload) => {
    state.exchange = payload
}

/** saves Last Charges List
@payload { Array }
*/
export const SAVE_LAST_CHARGES = (state, payload) => {
	state.lastChargesList = payload.data.cardTopups
}

/** saves Favorites List
@payload { Array }
*/
export const SAVE_FAVORITES_LIST = (state, { pageNumber, data }) => {
	state.favoritesList = pageNumber === 1 ? data.favorites : state.favoritesList.concat(data.favorites)
	state.favoritesHasMore = state.favoritesList.length < data.total
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
	state.accountsBalances = []
	state.cardsList = []
	state.availablePlafond = []
	state.exchange = []
	state.lastChargesList = []
	state.favoritesList = []
	state.favoritesHasMore = false
}
